import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type CheckboxOptionClasses =
  | 'container'
  | 'gridContainer'
  | 'itemContainer'
  | 'imageContainer'
  | 'imageUnavailable'
  | 'detailsContainer'
  | 'selectionContainer';

const checkboxOptionStyles = makeStyles<ISpcTheme, CheckboxOptionClasses>(
  ({ palette, breakpoints }) => ({
    container: {
      padding: '5px 0 0',
    },
    gridContainer: {
      marginBottom: '16px',
      '&:hover': {
        cursor: 'pointer',
      },
      [breakpoints.down('sm')]: {
        padding: '5px',
      },
    },
    itemContainer: {
      backgroundColor: palette.background.alternate,
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    imageContainer: {
      borderRadius: '10px 10px 0 0',
    },
    imageUnavailable: {
      width: '100%',
      height: 'auto',
    },
    detailsContainer: {
      padding: '8px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    selectionContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '15px',
      [breakpoints.down('md')]: {
        marginTop: '8px',
      },
    },
  }),
  { name: 'Customise_simpleBrands_CheckboxOption' },
);

export default checkboxOptionStyles;
